import { Group, ThemeIcon, Tooltip } from '@mantine/core';
import { IconCheck, IconMinus } from '@tabler/icons-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { getHarvestProofReminderSteps } from '../../utils/harvest-proof-reminder-schedule';

import { formatDate } from '@data-access';

export interface HarvestProofReminderState {
  reminder1_sent: boolean;
  reminder1_sent_at?: string | null;
  reminder2_sent: boolean;
  reminder2_sent_at?: string | null;
  reminder3_sent: boolean;
  reminder3_sent_at?: string | null;
  campaign_year?: number | null;
}

interface HarvestProofRemindersStatusProps {
  form: HarvestProofReminderState;
  size?: 'sm' | 'md';
}

export const HarvestProofRemindersStatus: FC<HarvestProofRemindersStatusProps> = ({
  form,
  size = 'sm',
}) => {
  const { t } = useTranslation();
  const steps = getHarvestProofReminderSteps(form);
  const iconSize = size === 'sm' ? 12 : 14;
  const themeSize = size === 'sm' ? 'sm' : 'md';

  return (
    <Group gap={6} wrap="nowrap">
      {steps.map((step) => {
        const label = t(step.labelKey);

        const tooltip = step.sent
          ? step.sentAt
            ? t('harvest-proof.reminders.sentAt', {
                label,
                date: formatDate({
                  date: step.sentAt,
                  format: 'display-hour',
                }),
              })
            : label
          : form.campaign_year
            ? t('harvest-proof.reminders.scheduled', {
                label,
                year: form.campaign_year,
              })
            : t('harvest-proof.reminders.notSent', { label });

        return (
          <Tooltip key={step.key} label={tooltip} withArrow>
            <ThemeIcon
              color={step.sent ? 'pf-green' : 'gray'}
              radius="xl"
              size={themeSize}
              variant={step.sent ? 'filled' : 'light'}
            >
              {step.sent ? (
                <IconCheck size={iconSize} stroke={3} />
              ) : (
                <IconMinus size={iconSize} stroke={2} />
              )}
            </ThemeIcon>
          </Tooltip>
        );
      })}
    </Group>
  );
};
